import React from 'react'
import styled from 'styled-components'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import InstagramIcon from '@material-ui/icons/Instagram';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import GitHubIcon from '@material-ui/icons/GitHub';
import {Link} from 'react-scroll'
import './Main.css'
function Main() {

const handleClick=()=>{
  window.scrollTo({
      top:740,
      behavior:'smooth',
  });
};

  

    return (
        <Section>
            <Wrapper>


            <Description className='main__desc'>
                <p>Hi,My name is</p>
                <h1>Shashwat</h1>
                <h1>I love building Websites</h1>
            </Description>
            <ButtonContainer className="main__btn">
                
                    <button ><Link to="works" activeClass="none" smooth={true}>Projects</Link></button>

                
                    <button><Link to="contact" activeClass="active"  spy={true} smooth={true}>Get In Touch</Link></button>
                
                
            </ButtonContainer>

            <ScrollDown className="main__btn-scroll" onClick={handleClick}>
                <span>Scroll Down</span>
                <ExpandMoreIcon />

            </ScrollDown>

                
                
              
            <HandlesContainer className="main__handles">

                <Handles className="main__handles-handler">
                    <a href="https://www.linkedin.com/in/shashwat-pal-9216981b4/" rel="noreferrer" target="_blank">
                <LinkedInIcon/>
                    </a>
                    <a href="https://github.com/Shashwat61" rel="noreferrer" target="_blank">
                <GitHubIcon/>
                    </a>

                    <a href="https://www.instagram.com/shashpaul/" rel="noreferrer" target="_blank">

                        <InstagramIcon/>
                    </a>
                </Handles>
                <Div/>

            </HandlesContainer>
            </Wrapper>
            
        </Section>
       
    )
}

export default Main




const Section=styled.div`
color:whitesmoke;
height:120vh;
width:100%;
`;

const Wrapper=styled.div`
letter-spacing:1px;
height:100%;
padding-top:35vh;
padding-left:5vw;
max-width:100vw;

`;

const Description=styled.div`
max-width:70%;
line-height:50px;
letter-spacing:2px;
p{
    
    margin-bottom:-20px;
    font-size:20px;
}

h1{
    font-size:60px;
}
@media screen and (max-width:768px){
    p{
        font-size:16px;
    }
    h1{
        font-size:40px;
    }
   
    /* flex-direction:column; */
}


`;
const ButtonContainer=styled.div`

max-width:25vw;
display:flex;
justify-content:space-between;
padding:0;
top:30vh;
left:5vw;

button{
    letter-spacing:2px;
    font-family:inherit;
    color:whitesmoke;
    border:2px solid whitesmoke;
    width:10em;
    background:transparent;
    padding:10px;
    transition:all 0.5s ease-in-out;
}

button:hover{
    cursor:pointer;
    transform:scale(1.05);
    background-color:white;
    color:black;
}
    
    @media screen and (max-width:768px){
        /* max-width:10vw; */
        button{
            padding:7px;
            margin-right:5px;
            font-size:x-small;
            /* width:50px; */
        }
        
    
    }

`;

const ScrollDown=styled.div`
margin:10% 0;
// border:2px solid whitesmoke;
max-width:15%;
display:flex;
justify-content:space-around;
align-items:center;

:hover{
    cursor:pointer;
    
}
@media screen and (max-width:768px){
 display:grid;
 place-items:center;
    
}
`;

const HandlesContainer=styled.div`
position:absolute;
display:flex;
right:5%;
top:70vh;
@media screen and (max-width:768px){
    position:absolute;
    display:flex;
    flex-direction:column;
    top:40%;

}


`;
const Handles=styled.div`
display:flex;
align-items:center;
justify-content:space-around;
.MuiSvgIcon-root{
    font-size:32px;
    padding:16px;
    transition:0.5s ease-in-out;
    color:white;
}
.MuiSvgIcon-root:hover{
    transform:scale(1.2);

}

a:visited{
    text-decoration:none;
    color:white;
}

@media screen and (max-width:768px){
    flex-direction:column;
    .MuiSvgIcon-root{
        font-size:20px;
    }
    a:visited{
        text-decoration: none;
        color:white;
    }

}
`;
const Div=styled.div`
background-color:whitesmoke;
height:2px;
 width:15vw;
`;


